import { styled } from 'goober';

export const Wrapper = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
